import { CaseFormData } from 'containers/pages/cases/types';

const initCase: CaseFormData = {
	Title: '',
	Description: '',
	StatusComment: '',
	StatusId: '1',
	StatusTitle: '',
	CustomerId: null,
	CustomerName: '',
	ConsultantId: null,
	ConsultantName: '',
	PrimaryContactId: null,
	PrimaryContactName: '',
	GroupId: null,
	GroupTitle: '',
	ProjectId: null,
	ProjectTitle: '',
	DeliverableId: null,
	DeliverableTitle: '',
	Keywords: [],
	References: [],
	KeywordTags: [],
	ReferenceTags: [],
	Private: true,
	IpRestricted: true,
};

export default initCase;
